export class DealServiceItemModel{
    id: number;
    dealID:number;
    description :string;
    price :number;
    remark: string;
    isBold: boolean;
}


// WEBPACK FOOTER //
// ./src/app/_models/deal-service-item.model.ts